import { ArrowDownOutlined, ArrowUpOutlined, SyncOutlined } from "@ant-design/icons";

// Waarden zoals de API ze logt: api/src/firestore/entities/edi-log.entity.ts
export const EDI_MESSAGE_TYPES = ["ORDERS", "APERAK", "DESADV", "INVOIC"];
export const EDI_EVENTS = ["received", "parsed", "processed", "generated", "sent"];
export const EDI_SOURCES = ["webhook", "cms", "system"];

export const EDI_MESSAGE_TYPE_COLORS = {
  ORDERS: "blue",
  APERAK: "cyan",
  DESADV: "purple",
  INVOIC: "gold",
};

export const EDI_DIRECTION_ICONS = {
  inbound: ArrowDownOutlined,
  outbound: ArrowUpOutlined,
  internal: SyncOutlined,
};

/**
 * Tijdstip (unix) van de laatste geslaagde logregel van dit type/event uit een
 * order-historie (nieuwste eerst, zie useOrderHistory).
 */
export const lastEdiEventAt = (history, messageType, events) =>
  history?.find(
    (entry) => entry.messageType === messageType && events.includes(entry.event) && entry.status === "success",
  )?.createdAt;
